import type { CatalogDimensionsDto, CatalogEntryDto, CatalogFiltersDto } from './dto';
import type { CatalogDimensions, CatalogEntry, CatalogFilters } from './types';

export function mapDimensions(dto: CatalogDimensionsDto): CatalogDimensions {
    return {
        id: dto.id,
        name: dto.name,
        source: dto.source,
        linkedBy: dto.linked_by,
        length: dto.length ?? null,
        width: dto.width ?? null,
        height: dto.height ?? null,
        weight: dto.maximum_load_weight ?? null,
        transportLength: dto.transport_length ?? null,
        transportWidth: dto.transport_width ?? null,
        transportHeight: dto.transport_height ?? null,
        transportWeight: dto.transport_weight ?? null,
        sizeUnits: dto.size_units || 'мм',
        weightUnits: dto.weight_units || 'г',
    };
}

export function mapEntry(dto: CatalogEntryDto): CatalogEntry {
    return {
        id: dto.id,
        number: dto.number,
        name: dto.name,
        sourceTitle: dto.source_title || null,
        brand: dto.brand || null,
        model: dto.model || null,
        imageUrl: dto.image_url || null,
        role: dto.role,
        mainEntryId: dto.main_entry_id ?? null,
        mainEntryNumber: dto.main_entry_number ?? null,
        analogsCount: dto.analogs_count ?? 0,
        projectId: dto.project_id,
        projectName: dto.project_name,
        authorEmail: dto.author_email,
        authorName: dto.author_name,
        productId: dto.product_id,
        createdAt: dto.created_at,
        dimensions: dto.dimensions ? mapDimensions(dto.dimensions) : null,
    };
}

export function mapFilters(dto: CatalogFiltersDto): CatalogFilters {
    return {
        projects: (dto.projects ?? []).map((p) => ({ value: p.id, label: p.name })),
        authors: (dto.authors ?? []).map((a) => ({ value: a.email, label: a.name })),
    };
}
